import { render, staticRenderFns } from "./TaskCommentLikeReply.vue?vue&type=template&id=708424fe&scoped=true&"
import script from "./TaskCommentLikeReply.vue?vue&type=script&lang=js&"
export * from "./TaskCommentLikeReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708424fe",
  null
  
)

export default component.exports